<template>
    <div id="layoutSidenav_nav" v-if="$store.getters.user.loggedIn">
      <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
        <div class="sb-sidenav-menu">
          <div class="nav">
            <router-link class="nav-link" to="/">
              <div class="sb-nav-link-icon"><i class="fas fa-home"></i></div>
              Anasayfa
            </router-link>
            <div class="sb-sidenav-menu-heading">Dersler</div>
            <div  v-for="(ders,i) in $store.getters.dersler" :key="ders.id">
              <a class="nav-link collapsed" href="#" @click="showMenu(i)">
                <div class="sb-nav-link-icon"><i :class="'fas '+this.icons[i]"></i></div>
                {{ders.isim}}
                <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
              </a>
              <div class="collapse" :class="collapse[i]" aria-labelledby="headingOne" data-parent="#sidenavAccordion">
                <nav class="sb-sidenav-menu-nested nav">
                  <router-link :to="`/${route.slug}/${ders.firebaseKey}`"  v-for="(route,i) in $store.getters.routes" :key="route.slug" class="nav-link">
                    {{route.name}}
                  <span v-if="sayilar && i===0" style="margin-left: 5px"> ({{sayilar[ders.firebaseKey].ozetler.sayi}}) </span>
                  <span v-if="sayilar && i===1" style="margin-left: 5px"> ({{sayilar[ders.firebaseKey].detaylianlatim.sayi}}) </span>
                  <span v-if="sayilar && i===2" style="margin-left: 5px"> ({{sayilar[ders.firebaseKey].konutestleri.sayi}}) </span>
                  <span v-if="sayilar && i===3" style="margin-left: 5px"> ({{sayilar[ders.firebaseKey].denemeler.sayi}}) </span>
                  <span v-if="sayilar && i===4" style="margin-left: 5px"> ({{sayilar[ders.firebaseKey].sifreler.sayi}}) </span>
                  <span v-if="sayilar && i===5" style="margin-left: 5px"> ({{sayilar[ders.firebaseKey].videolar.sayi}}) </span>
                  </router-link>
                </nav>
              </div>
            </div>
            <div class="sb-sidenav-menu-heading">Güncelleme İşlemi</div>
            <div>
              <a href="#" class="nav-link collapsed" @click="sayilariGuncelle">Tüm İçerik Sayılarını Güncelle</a>
            </div>
          </div>
        </div>

        <div class="sb-sidenav-footer">
          <div class="small">Logged in as:</div>
          {{ user?.data?.email }}
        </div>
      </nav>
    </div>
</template>

<script>
import { get, remove, update } from '@/crud'

export default {
  name: 'Sidebar',
  data () {
    return {
      user: this.$store.getters.user,
      geciciSayi: 0,
      geciciSayi2: 0,
      sayilar: false,
      icons: [
        'fa-book',
        'fa-gavel',
        'fa-history',
        'fa-globe-asia',
        'fa-divide'

      ],
      collapse: [
        '',
        '',
        '',
        '',
        ''
      ]
    }
  },
  methods: {
    showMenu (i) {
      const oldCollape = this.collapse[i]
      this.collapse = ['', '', '', '', '']
      if (oldCollape !== 'show') {
        this.collapse[i] = 'show'
      }
    },
    plusGeciciSayi (sayi) {
      this.geciciSayi += sayi
    },
    plusGeciciSayi2 (sayi) {
      this.geciciSayi2 += sayi
    },
    sayilariGuncelle () {
      remove('sayilar', () => {
        this.$store.getters.dersler.map(ders => {
          const denemeChild = 'deneme-sinavlar/' + ders.firebaseKey
          get({
            child: denemeChild,
            callback: (e) => {
              const sayi = e.numChildren()
              update('sayilar/' + ders.firebaseKey + '/denemeler', { sayi }, () => {})
              const val = e.val()
              this.geciciSayi = 0
              Object.keys(val).map(key => {
                const denemesorularChild = 'deneme-sorular/' + key
                get({
                  child: denemesorularChild,
                  callback: (e) => {
                    this.plusGeciciSayi(e.numChildren())
                  }
                })
              })
              update('sayilar/' + ders.firebaseKey + '/denemesorular', { sayi: this.geciciSayi }, () => {})
            }
          })
          const ozetlerChild = 'ozetler/' + ders.firebaseKey
          get({
            child: ozetlerChild,
            callback: (e) => {
              const sayi = e.numChildren()
              update('sayilar/' + ders.firebaseKey + '/ozetler', { sayi }, () => {})
            }
          })
          const detaliChild = 'detaylianlatim/' + ders.firebaseKey
          get({
            child: detaliChild,
            callback: (e) => {
              const sayi = e.numChildren()
              update('sayilar/' + ders.firebaseKey + '/detaylianlatim', { sayi }, () => {})
            }
          })
          const sifrelerChild = 'sifreler/' + ders.firebaseKey
          get({
            child: sifrelerChild,
            callback: (e) => {
              const sayi = e.numChildren()
              update('sayilar/' + ders.firebaseKey + '/sifreler', { sayi }, () => {})
            }
          })
          const konuTestiChild = 'konu-testleri-kategoriler/' + ders.firebaseKey
          get({
            child: konuTestiChild,
            callback: (e) => {
            // const sayi = e.numChildren()
            // update('sayilar/' + child, { sayi }, () => {})
              const val = e.val()
              this.geciciSayi = 0
              this.geciciSayi2 = 0
              Object.keys(val).map(key => {
                const konuTestiSinavChild = 'konu-testleri-sinavlar/' + key
                get({
                  child: konuTestiSinavChild,
                  callback: (e) => {
                    this.plusGeciciSayi(e.numChildren())
                    const val = e.val()

                    Object.keys(val).map(key => {
                      const konutestiSorular = 'konu-testleri-sorular/' + key
                      get({
                        child: konutestiSorular,
                        callback: (e) => {
                          this.plusGeciciSayi2(e.numChildren())
                        }
                      })
                    })
                  }
                })
              })
              update('sayilar/' + ders.firebaseKey + '/konutestisorular', { sayi: this.geciciSayi2 }, () => {})
              update('sayilar/' + ders.firebaseKey + '/konutestleri', { sayi: this.geciciSayi }, () => {})
            }
          })
          const videoHocaChild = 'video-hocalar/' + ders.firebaseKey
          get({
            child: videoHocaChild,
            callback: (e) => {
              const val = e.val()
              this.geciciSayi = 0
              Object.keys(val).map(key => {
                const videolarVideoChild = 'video-videolar/' + key
                get({
                  child: videolarVideoChild,
                  callback: (e) => {
                    this.plusGeciciSayi(e.numChildren())
                  }
                })
              })
              update('sayilar/' + ders.firebaseKey + '/videolar', { sayi: this.geciciSayi }, () => {})
            }
          })
        })
      })
    }
  },
  created () {
    get({
      child: 'sayilar',
      callback: (e) => {
        this.sayilar = e.val()
      }
    })
  }
}
</script>

<style >

</style>
